import { render } from "./CreateEditComponent.vue?vue&type=template&id=36b1fc0a"
import script from "./CreateEditComponent.vue?vue&type=script&lang=js"
export * from "./CreateEditComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__